import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForCustomers = () => {
  return {
    customers: [],
    debtor_accounts:[],
    metas_config:[],
    data:{},
    is_created:null,
    is_updated:null,
    is_deleted:null,
    filter:{
      keyword:"",
      active_only:"1"
    },
    business_units:[]
  }
}

// state
const state = getDefaultStateForCustomers()

// getters
const getters = {

}
// mutations
const mutations = {
    SET_DEBTOR_ACCOUNTS (state, data){
      state.debtor_accounts = data
    },
    RESET_STATE_FOR_CUSTOMERS (state) {
      Object.assign(state, getDefaultStateForCustomers())
    },
    QUICK_SEARCH(state, data){
        data.forEach(function (element) {
          element.contact_email = (element.contact_email != null && element.contact_email != '') ? (element.contact_email) : '-'
          element.contact_telephone = (element.contact_telephone != null && element.contact_telephone != '') ? (element.contact_telephone) : '-'

      });

      state.customers = data

    },
    SET_METAS_CONFIG(state, data)
    {
      state.metas_config = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    FETCH(state, data){
      if(data)
      {
        state.data = data
        data.units.forEach(function (element) {
          element.is_collapsed = false
        });
        data.bank_accounts.forEach(function (element) {
            element.is_locked = true
        });
      }
    },
    FETCH_BUSINESS_UNITS(state, data)
    {
      if(data)
      {

        data.forEach(function (element) {
            element.is_selected = "0",
            element.style = "background-color:transparent;color:black"
        });
        state.business_units = data
      }
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_CUSTOMERS")
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['CUSTOMER_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('QUICK_SEARCH', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('QUICK_SEARCH', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem submitting New Customer", error);
              }
          });
    },
    fetchMetaConfig({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_META_CONFIG'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('SET_METAS_CONFIG', response.data.data)
            } else {
              commit('SET_METAS_CONFIG', [])
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    fetchDebitorAccounts({ commit }, data) {
      return axios.post(apiRoutes['GET_DEFAULT_DEBTOR_ACCOUNTS'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('SET_DEBTOR_ACCOUNTS', response.data.data)
            } else {
              commit('SET_DEBTOR_ACCOUNTS', [])
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_CUSTOMER'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
   fetchBusinessUnits({ commit }, data) {
    return axios.post(apiRoutes['LIST_BUSINESS_UNITS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('FETCH_BUSINESS_UNITS', response.data.data)
          } else {
            commit('FETCH_BUSINESS_UNITS', {})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
 },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_CUSTOMER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_CREATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Customer (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Customer")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['UPDATE_CUSTOMER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_UPDATED', 1);

                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Customer (' + doc_number + ')' + " has been updated!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                commit('SET_IS_UPDATED', 0);


                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Customer")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['DELETE_CUSTOMER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Customer (' + doc_number + ')' + " has been deleted!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_DELETED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_DELETED', 0);
            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Customer")
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
